import { IGetPaymentsHistoryResponse } from 'services/payments/payments/types';

interface IDataLayerWindow extends Window {
  dataLayer?: Record<string, unknown>[];
}

const getPurchaseItemVariant = (billingPeriod: string | undefined): string => {
  if (billingPeriod === 'Annually') {
    return 'Yearly';
  }

  return 'Monthly';
};

export const trackPurchase = (paymentData: IGetPaymentsHistoryResponse): boolean => {
  const dataLayer = (window as IDataLayerWindow).dataLayer;

  if (!paymentData.content.length || !dataLayer) {
    return false;
  }

  const latestPayment = paymentData.content[0];
  const operationId = latestPayment.operationId;
  const storageKey = `ga_purchase_tracked_${operationId}`;

  if (sessionStorage.getItem(storageKey)) {
    return true;
  }

  const subscriptionNameParts = latestPayment.order.subscription.name.split(' ');
  const itemName = subscriptionNameParts[0];
  const billingPeriod = subscriptionNameParts[1];
  const currency = latestPayment.order.subscription.currency.toUpperCase();
  const price = latestPayment.order.subscription.price / 100;

  sessionStorage.setItem(storageKey, '1');

  dataLayer.push({
    event: 'purchase',
    ecommerce: {
      transaction_id: operationId,
      value: price,
      tax: 0,
      shipping: 0,
      currency,
      items: [
        {
          item_name: itemName,
          item_variant: getPurchaseItemVariant(billingPeriod),
          price,
          quantity: 1,
        },
      ],
    },
  });

  return true;
};
